import { HttpClient } from '@angular/common/http';
import { Injectable, signal } from '@angular/core';
import { IBusinessCard } from '@interfaces';
import { ApiResponse } from '@shared';
import { SeoService } from './seo.service';

@Injectable({
  providedIn: 'root',
})
export class BusinessCardService {
  constructor(
    private http: HttpClient,
    private seoService: SeoService,
  ) {}

  viewBusinessCard(id: string) {
    return this.http.get<ApiResponse>(`/v1/business-card/view/${id}/`);
  }

  getOriginalUrl(nanoid: string) {
    return this.http.get<ApiResponse>(`/v1/business-card/original-url/${nanoid}/`);
  }

  setBusinessCardDetails(data: IBusinessCard) {
    this.seoService.setMetaTitles(data);
  }
}
